import { render } from "src/website-apps/shared/utils/render";
import { PolicyRoot } from "./root";

render(<PolicyRoot />);
